import type { AuthUser } from '../services/authApi';

// In-memory token store — not accessible to XSS unlike localStorage
const store = new Map<string, string>();

const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const USER_KEY = 'user';

export const tokenStorage = {
  getToken(): string | null {
    return store.get(TOKEN_KEY) ?? null;
  },

  setToken(token: string): void {
    store.set(TOKEN_KEY, token);
  },

  getRefreshToken(): string | null {
    return store.get(REFRESH_TOKEN_KEY) ?? null;
  },

  setRefreshToken(token: string): void {
    store.set(REFRESH_TOKEN_KEY, token);
  },

  getStoredUser(): AuthUser | null {
    const s = store.get(USER_KEY);
    if (!s) return null;
    try {
      return JSON.parse(s);
    } catch {
      return null;
    }
  },

  storeUser(user: AuthUser): void {
    store.set(USER_KEY, JSON.stringify(user));
  },

  clearAll(): void {
    store.delete(TOKEN_KEY);
    store.delete(REFRESH_TOKEN_KEY);
    store.delete(USER_KEY);
  },

  isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  },
};
